import React from 'react';
const testimonials = [{
  quote: 'Una crónica que no podés soltar. Cada capítulo te deja con más preguntas.',
  name: 'M.R.',
  city: 'Buenos Aires'
}, {
  quote: 'Pensé que sabía todo sobre el caso. Este libro me demostró que no.',
  name: 'C.L.',
  city: 'Montevideo'
}, {
  quote: 'El nivel de detalle y documentación es impresionante. Lectura obligatoria.',
  name: 'P.G.',
  city: 'Asunción'
}];
function Stars() {
  return <div className="flex gap-1 justify-center mb-4" data-id="element-126">
      {[...Array(5)].map((_, i) => <span key={i} className="text-[#C5A014] text-lg" data-id="element-127">
          ★
        </span>)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full py-20 md:py-24 px-4 bg-black" data-id="element-128">
      <div className="max-w-5xl mx-auto" data-id="element-129">
        <h2 className="font-['Playfair_Display'] font-bold text-3xl md:text-4xl text-zinc-200 mb-14 text-center" data-id="element-130">
          Lo que dicen los primeros lectores
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-131">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-zinc-950 border border-zinc-800/60 p-8 flex flex-col items-center text-center" data-id="element-132">
              <Stars data-id="element-133" />
              <p className="font-['Crimson_Text'] text-lg text-zinc-300 leading-relaxed italic mb-6" data-id="element-134">
                "{testimonial.quote}"
              </p>
              <p className="font-['Crimson_Text'] text-sm text-zinc-500" data-id="element-135">
                — {testimonial.name}, {testimonial.city}
              </p>
              <p className="font-['Crimson_Text'] text-xs text-zinc-500 mt-2 flex items-center gap-1" data-id="element-136">
                Compra verificada{' '}
                <span className="text-[#C5A014] text-xs" data-id="element-137">✓</span>
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}